import Header from './Header'
import Footer from './Footer'

interface LayoutProps {
  children: React.ReactNode
  showFooter?: boolean
  className?: string
}

export default function Layout({ children, showFooter = true, className = '' }: LayoutProps) {
  return (
    <div className={`min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-gray-950 flex flex-col ${className}`}>
      <Header />
      <main className="flex-1">
        {children}
      </main>
      {showFooter && <Footer />}
    </div>
  )
}

export { Header, Footer }
